import React from 'react';
import { FaGhost } from 'react-icons/fa';

/**
 * EmptyState - Consistent empty state component
 * Shows when no data is available
 */
const EmptyState = ({
  icon: Icon = FaGhost,
  title = 'No data found',
  message = '',
  action,
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}>
      <Icon className="text-6xl text-gray-300 dark:text-spooky-bg-light mb-4 animate-float" />
      <h3 className="text-xl font-semibold text-gray-700 dark:text-spooky-ghost-white mb-2">
        {title}
      </h3>
      {message && (
        <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md">
          {message}
        </p>
      )}
      {action}
    </div>
  );
};

export default EmptyState;
